// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".secondary-details p{margin-top:8px}.secondary-details .content{margin-top:8px}.secondary-details{margin-bottom:22px}", ""]);
// Exports
module.exports = exports;
